import Vue from "vue";
import { Street } from "./street";

export class Condominios {
    static create() {
        return {
            nome: null,
            street: Street.create(),
            blocos: [],
            place: [0, 0]
        };
    }

    /**
     *
     * @return {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("condominio/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("condominios")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("condominio", data);
            } else {
                promisse = Vue.http.post("condominio", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
